export * from './lib/assign-soaking-material';
